<template>
	<router-view />
</template>

<script>
import { mapActions } from 'vuex';

export default {
	props: {
		companyId: {
			type: Number,
			default: undefined
		}
	},
	async created() {
		await this.currentCompanyIdAction(this.companyId);
	},
	methods: {
		...mapActions('user', ['currentCompanyIdAction'])
	}
};
</script>
